// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  tournamentId: __t.u64().name("tournament_id"),
  userId: __t.u64().name("user_id"),
  username: __t.string(),
  bestTimeMs: __t.u32().name("best_time_ms"),
  attempts: __t.u32(),
  enteredAt: __t.u64().name("entered_at"),
});
